import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';

import { TranslocoLoader } from '@jsverse/transloco';
import { catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomTranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http
      .get(`${environment.url.bffInternBETranslations}MeteoFocus/${lang}.json`)
      .pipe(catchError(() => of({})));
  }
}
